import type { TeacherPayoutVM } from "@shared-kernel/application/ports/teacher/teacher-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const teacherRetrievePayouts = createApiThunk<TeacherPayoutVM[], void>(
  "payouts/teacherRetrievePayouts",
  async (_: void, { extra: { teacherRepository } }) => {
    return teacherRepository!.getTeacherPayouts();
  },
);
